import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Card,
  CardBody,
  Title,
  Copy,
  Bold,
  ProgressBar,
  Spin
} from "app/NativeComponents/common";

import { BottomNavBar } from "app/NativeComponents/snippets";
import { getBulkEdits, numberWithCommas } from "app/NativeActions";

class BulkLoading extends Component {
  componentDidMount() {
    this.props.getBulkEdits({ token: this.props.token });
  }
  render() {
    const { bulk_edits, user, colors } = this.props;

    if (bulk_edits && bulk_edits?.length > 0) {
      return (
        <>
          {bulk_edits.map((bulk_edit, i) => {
            if (parseInt(bulk_edit.percent_complete) / 100 < 1 && i == 0) {
              return (
                <BottomNavBar key={"bulk_edit_" + i + "_" + bulk_edit.id}>
                  <Wrapper style={{ padding: 25, paddingBottom: 15 }}>
                    <Wrapper style={{ marginBottom: 10 }}>
                      <Spin text={bulk_edit.text} />
                    </Wrapper>
                    <ProgressBar
                      style={{ marginTop: 0 }}
                      color={colors.success_color}
                      backgroundColor={colors.white_color}
                      width={300}
                      progress={parseInt(bulk_edit.percent_complete) / 100}
                    />
                  </Wrapper>
                </BottomNavBar>
              );
            }
            return null;
          })}
        </>
      );
    }

    return null;
  }
}

const mapStateToProps = ({ auth, settings, native, lead }) => {
  const { token, user } = auth;
  const { colors } = settings;
  const { isMobile } = native;
  const { bulk_edits } = lead;

  return {
    token,
    user,
    colors,
    isMobile,
    bulk_edits
  };
};

export default connect(mapStateToProps, {
  getBulkEdits
})(BulkLoading);
